export default "<p>supervisores-tabla works!</p>\n"